import { t } from '../../i18n';

// Copy unificada para onboarding e empty states (Épico 37) — 5 locales via i18n.
export function getOnboardingCopy() {
  return {
    atlasEmpty: {
      title: t('web.onboarding.atlasEmpty.title'),
      message: t('web.onboarding.atlasEmpty.message'),
      cta: t('web.onboarding.atlasEmpty.cta'),
    },
    diaEmpty: {
      title: t('web.onboarding.diaEmpty.title'),
      message: t('web.onboarding.diaEmpty.message'),
      cta: t('web.onboarding.diaEmpty.cta'),
    },
    historiasEmpty: {
      title: t('web.onboarding.historiasEmpty.title'),
      message: t('web.onboarding.historiasEmpty.message'),
      cta: t('web.onboarding.historiasEmpty.cta'),
    },
    pulseInvalidPeriod: {
      title: t('web.onboarding.pulseInvalid.title'),
      message: t('web.onboarding.pulseInvalid.message'),
    },
    pulseEmptyPeriod: {
      title: t('web.onboarding.pulseEmpty.title'),
      message: t('web.onboarding.pulseEmpty.message'),
      cta: t('web.onboarding.pulseEmpty.cta'),
    },
  };
}

/** @deprecated Prefer getOnboardingCopy() so strings resolve at call time. */
export const ONBOARDING_COPY = new Proxy(
  {},
  {
    get(_target, prop) {
      return getOnboardingCopy()[prop];
    },
  },
);

export function getOnboardingChecklistSteps() {
  return [
    {
      id: 'period',
      title: t('web.checklist.step.period.title'),
      body: t('web.checklist.step.period.body'),
    },
    {
      id: 'lenses',
      title: t('web.checklist.step.lenses.title'),
      body: t('web.checklist.step.lenses.body'),
    },
    {
      id: 'import',
      title: t('web.checklist.step.import.title'),
      body: t('web.checklist.step.import.body'),
    },
  ];
}

/** @deprecated Prefer getOnboardingChecklistSteps(). */
export const ONBOARDING_CHECKLIST_STEPS = new Proxy([], {
  get(target, prop) {
    const steps = getOnboardingChecklistSteps();
    if (prop === 'length') return steps.length;
    if (prop === Symbol.iterator) return steps[Symbol.iterator].bind(steps);
    if (typeof prop === 'string' && /^\d+$/.test(prop)) return steps[Number(prop)];
    if (prop === 'map') return steps.map.bind(steps);
    if (prop === 'forEach') return steps.forEach.bind(steps);
    if (prop === 'filter') return steps.filter.bind(steps);
    return Reflect.get(steps, prop);
  },
});

// Cards de fontes no checklist dado-zero (Épico 40 / plano 3.5).
export function getOnboardingSourceCards() {
  return [
    {
      id: 'google_maps',
      featureKey: 'google_maps',
      title: t('web.source.google_maps.title'),
      downloadHint: t('web.source.google_maps.hint'),
      cta: t('web.source.google_maps.cta'),
    },
    {
      id: 'spotify',
      featureKey: 'spotify',
      title: t('web.source.spotify.title'),
      downloadHint: t('web.source.spotify.hint'),
      cta: t('web.source.spotify.cta'),
    },
    {
      id: 'trakt',
      featureKey: 'movie',
      statusKeys: ['movie', 'shows'],
      title: t('web.source.trakt.title'),
      downloadHint: t('web.source.trakt.hint'),
      cta: t('web.source.trakt.cta'),
    },
    {
      id: 'health',
      featureKey: 'health',
      title: t('web.source.health.title'),
      downloadHint: t('web.source.health.hint'),
      cta: t('web.source.health.cta'),
    },
    {
      id: 'checkin',
      featureKey: 'checkin',
      title: t('web.source.checkin.title'),
      downloadHint: t('web.source.checkin.hint'),
      cta: t('web.source.checkin.cta'),
    },
  ];
}

/** @deprecated Prefer getOnboardingSourceCards(). */
export const ONBOARDING_SOURCE_CARDS = new Proxy([], {
  get(_target, prop) {
    const cards = getOnboardingSourceCards();
    if (prop === 'length') return cards.length;
    if (prop === Symbol.iterator) return cards[Symbol.iterator].bind(cards);
    if (typeof prop === 'string' && /^\d+$/.test(prop)) return cards[Number(prop)];
    if (prop === 'map') return cards.map.bind(cards);
    if (prop === 'forEach') return cards.forEach.bind(cards);
    if (prop === 'filter') return cards.filter.bind(cards);
    return Reflect.get(cards, prop);
  },
});

/** True se /api/integrations/status.status tem count>0 em qualquer statusKey do card. */
export function isOnboardingSourceDone(card, statusMap) {
  if (!card || !statusMap) return false;
  const keys = card.statusKeys || [card.featureKey];
  return keys.some((key) => (statusMap[key]?.count || 0) > 0);
}
